import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNumber.js
// module id = aKW8
// module chunks = 0